import {
	type IApiResponse,
	type IElectoralDivisionMetaDataFormHook,
	type ILGAByIDState,
	type ILGAInState,
	type ILGAStates,
} from '@/helpers/types';
import { getCoreQuery, type IGetQuery } from '@/store/actions/api-utils';
import { type ICreateUpdateLGA } from '@/store/actions/core/lga';

import { coreApiSlice } from '../apiSlice';

const lgaApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createLGA: builder.mutation<IApiResponse, ICreateUpdateLGA>({
			query: (body) => ({
				url: '/LGA',
				method: 'POST',
				body,
			}),
		}),
		getLGA: builder.query<ILGAStates, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/LGA${getCoreQuery(paged, ...(query || []))}`,
			}),
		}),
		getLGAById: builder.query<ILGAByIDState, { id: string }>({
			query: ({ id }) => ({
				url: `/LGA/${id}`,
			}),
		}),
		getLGAByName: builder.mutation<IApiResponse, { name: string }>({
			query: (body) => ({
				url: '/LGA/name',
				method: 'POST',
				body,
			}),
		}),
		getLGAByCode: builder.query<IApiResponse, { code: string }>({
			query: (body) => ({
				url: '/LGA/code',
				method: 'POST',
				body,
			}),
		}),
		getLGAInState: builder.mutation<IApiResponse<ILGAInState[]>, { stateIds: number[] }>({
			query: (body) => ({
				url: '/LGA/getLgasInState',
				method: 'POST',
				body,
			}),
		}),
		updateLGA: builder.mutation<IApiResponse, ICreateUpdateLGA>({
			query: (body) => ({
				method: 'PUT',
				url: '/LGA/update',
				body,
			}),
		}),
		deleteLGA: builder.mutation<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				url: `/LGA/delete/${id}`,
				method: 'DELETE',
			}),
		}),
		updateLGAMetaData: builder.mutation<IApiResponse, { id: number; data: IElectoralDivisionMetaDataFormHook }>({
			query: ({ id, data }) => ({
				url: `/LGA/updatemetadata/${id}`,
				method: 'PUT',
				body: data,
			}),
		}),
	}),
});

export const {
	useCreateLGAMutation,
	useDeleteLGAMutation,
	useGetLGAByCodeQuery,
	useLazyGetLGAByCodeQuery,
	useGetLGAByIdQuery,
	useLazyGetLGAByIdQuery,
	useGetLGAByNameMutation,
	useGetLGAInStateMutation,
	useGetLGAQuery,
	useLazyGetLGAQuery,
	useUpdateLGAMetaDataMutation,
	useUpdateLGAMutation,
} = lgaApiSlice;
